import { render } from "./App.vue?vue&type=template&id=a363e52e&scoped=true"
const script = {}

import "./App.vue?vue&type=style&index=0&id=a363e52e&lang=scss&scoped=true"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a363e52e"]])

export default __exports__